import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { Question } from 'types/question.types';

import { FeedbackQuestionsFragment } from '../common';

export interface QuestionSortOrder {
  questionId: number;
  sortOrder: number;
}

export interface ReorderEventFeedbackQuestionsInput {
  eventId: number;
  questionSortOrders: QuestionSortOrder[];
}

export interface ReorderEventFeedbackQuestionsResult {
  reorderEventFeedbackQuestions: {
    ok: boolean;
    event: {
      id: number;
      postQuestions: Question[];
    };
  };
}

const ReorderEventFeedbackQuestionsMutation = gql`
  mutation reorderEventFeedbackQuestions($input: ReorderEventFeedbackQuestionsInput!) {
    reorderEventFeedbackQuestions(input: $input) {
      ok
      event {
        id
        postQuestions {
          ...FeedbackQuestionsFragment
        }
      }
    }
  }
  ${FeedbackQuestionsFragment}
`;

export const reorderEventFeedbackQuestions = (
  input: ReorderEventFeedbackQuestionsInput
): Promise<ReorderEventFeedbackQuestionsResult> => {
  return gqlClient.request<ReorderEventFeedbackQuestionsResult>(
    ReorderEventFeedbackQuestionsMutation,
    {
      input
    }
  );
};
